import React from "react";
import { Table } from "reactstrap";
import { object } from "prop-types";
import moment from "moment";

const NEGATIVE_MEDIA_TYPES = {
  1: "Negative media",
  2: "Semantic Negative media",
};

export const NEGATIVE_MEDIA_DECISION_LABELS = {
  0: "In Review",
  1: "False Positive",
  2: "True Match",
};

const NegativeMediaIgnoringPropertiesTable = ({
  singleClientReportDetails,
}) => {
  const linkLabel = singleClientReportDetails.linkLabel;

  const rows =
    singleClientReportDetails.negativeMediaSearchingDecisions != null
      ? singleClientReportDetails.negativeMediaSearchingDecisions.map(
          (entry, index) => {
            return (
              <tr key={index}>
                <td className="font-weight-bolder">
                  {NEGATIVE_MEDIA_TYPES[entry.negativeMediaType]}
                </td>
                <td className="font-weight-bolder">
                  {singleClientReportDetails.clientName}
                </td>
                <td>
                  {entry.clientNegativeMediaCheckResult.createDate
                    ? moment
                        .utc(entry.clientNegativeMediaCheckResult.createDate)
                        .local()
                        .format("DD.MM.YYYY HH:mm:ss")
                    : null}
                </td>
                <td>
                  {entry.createDate
                    ? moment
                        .utc(entry.createDate)
                        .local()
                        .format("DD.MM.YYYY HH:mm:ss")
                    : null}
                </td>
                <td>{NEGATIVE_MEDIA_DECISION_LABELS[entry.type]}</td>
                <td>{entry.user.name}</td>
                <td>{entry.negativeMediaSearchingDecisionComment.comment}</td>
                <td>
                  <a href={entry.monitoringQueueLink} target="_blank">
                    {linkLabel}
                  </a>
                </td>
              </tr>
            );
          }
        )
      : "";
  return (
    <Table className="single-client-report-entries-table">
      <thead>
        <tr>
          <th>{singleClientReportDetails.negativeMediaTypeLabel}</th>
          <th>{singleClientReportDetails.clientNameLabel}</th>
          <th>{singleClientReportDetails.checkDateLabel}</th>
          <th>{singleClientReportDetails.decisionDateLabel}</th>
          <th>{singleClientReportDetails.officerDecisionLabel}</th>
          <th>{singleClientReportDetails.officerLabel}</th>
          <th>{singleClientReportDetails.commentLabel}</th>
          <th>{linkLabel}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot />
    </Table>
  );
};
NegativeMediaIgnoringPropertiesTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default NegativeMediaIgnoringPropertiesTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/negative-media-ignoring-properties/NegativeMediaIgnoringPropertiesTable.jsx